import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useState } from "react";
import Swal from "sweetalert2";
import Topbar from "../Topbar/Topbar";
import { FiUpload } from "react-icons/fi";
import axios from "axios";
import "./MyTask.css";
import { Modal, Button, Form } from "react-bootstrap";
import { CloudUpload } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { useRef } from "react";
import _ from "lodash";
import dayjs from "dayjs";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaStarOfLife } from "react-icons/fa6";
import { useEffect } from "react";
import MessageBox from "../MessageBox/MessageBox";

export default function MyTask() {
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [showMessageBox, setShowMessageBox] = useState(false);
  const [messageData, setMessageData] = useState(null);
  const [pageRefId, setpageRefId] = useState("");

  const [show, setShow] = useState(false);
  const [reason, setReason] = useState("");
  const [file, setFile] = useState(null);

  // Show Popup
  const handleShow = () => setShow(true);
  // Close Popup
  const handleClose = () => setShow(false);
  const [showButtons, setShowButtons] = useState(true);
  const [showUpdate, setShowUpdate] = useState(false);

  //   function formatDate(dateString) {
  //   const [year, month, day] = dateString.split("-");
  //   return `${day}-${month}-${year}`;
  // }

  // File Upload Function
  const handleFileChange1 = (e) => {
    setFile(e.target.files[0]);
  };

  const formatDateDate = (dateString) => {
    if (!dateString) return "";
    const [year, month, day] = dateString.split("-");
    return `${day}-${month}-${year}`;
  };

  function convertTo12Hour(timeStr) {
    if (!timeStr) return "";

    const [hourStr, minuteStr] = timeStr.split(":");
    const hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);

    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 === 0 ? 12 : hour % 12;

    return `${hour12.toString().padStart(2, "0")}:${minuteStr} ${ampm}`;
  }

  // Example:
  // Output: 05:48 PM

  // Submit Function
  // const handleSubmit = () => {
  //   console.log("Reason:", reason);
  //   console.log("File:", file);
  //   handleClose();
  //   navigate("/task");
  // };

  // const gotoviewEnquiry = (leadId) => {
  //   // navigate("/view_enquiry",{
  //   //   state: { leadId: leadId }
  //   // });

  //   let route = "";

  //   switch (taskDetails.taskName?.toLowerCase()) {
  //     case "enquiry":
  //       route = "/view_enquiry";
  //       break;
  //     case "installation":
  //       route = "/view_installation";
  //       break;
  //     case "recovery":
  //       route = "/recovery-view";
  //       break;
  //     case "compliant":
  //       route = "/compliant-view";
  //       break;
  //     default:
  //       route = "/task-view";
  //   }

  //   //Pass leadId through navigation state
  //   navigate(route, { state: { leadId } });
  // };

  //  const gotoviewEnquiry = (leadId,id) => {
  //   let route = "";
  //   let activeTab = taskDetails.activeTab || "orderDetails"; // Default to "orderDetails" if not defined

  //   switch (taskDetails.taskName?.toLowerCase()) {
  //     case "enquiry":
  //       route = "/view_enquiry";
  //       break;
  //     case "installation":
  //       route = "/view_installation";
  //       break;
  //     case "recovery":
  //       route = "/recovery-view";
  //       break;
  //     case "compliant":
  //       route = "/compliant-view";
  //       break;
  //     default:
  //       route = "/view_createtask";
  //   }

  //   if(id){
  //     navigate(route, { state: { id } });
  //     return;
  //   }

  //   // Pass both leadId and activeTab as state
  //   navigate(route, { state: { leadId, activeTab } });
  // };

  //  const gotoviewEnquiry = (leadId, id) => {
  //   let route = "";
  //   let activeTab = taskDetails.activeTab || "orderDetails"; // Default to "orderDetails" if not defined

  //   switch (taskDetails.taskName?.toLowerCase()) {
  //     case "enquiry":
  //       route = "/view_enquiry";
  //       break;
  //     case "installation":
  //       route = "/view_installation";
  //       break;
  //     case "recovery":
  //       route = `/viewrecovery`;
  //       break;
  //     case "compliant":
  //       route = "/compliant-view";
  //       break;
  //     default:
  //       route = "/view_createtask";
  //   }

  //  const gotoviewEnquiry = (leadId,id) => {
  //   let route = "";
  //   let activeTab = taskDetails.activeTab || "orderDetails"; // Default to "orderDetails" if not defined

  //   switch (taskDetails.taskName?.toLowerCase()) {
  //     case "enquiry":
  //       route = "/view_enquiry";
  //       break;
  //     case "installation":
  //       route = "/view_installation";
  //       break;
  //     case "recovery":
  //       route = "/recovery-view";
  //       break;
  //     case "compliant":
  //       route = "/compliant-view";
  //       break;
  //     default:
  //       route = "/view_createtask";
  //   }

  //   if(id){
  //     navigate(route, { state: { id } });
  //     return;
  //   }

  //   // Pass both leadId and activeTab as state
  //   navigate(route, { state: { leadId, activeTab } });
  // };

  // const gotoviewEnquiry = (leadId) => {
  //   let route = "";
  //   let activeTab = taskDetails.activeTab || "orderDetails";
  //   let taskName = taskDetails.taskName?.toLowerCase();

  //   let payload = { leadId, activeTab,hideButtons: true, taskId: taskDetails._id,  };

  //   switch (taskName) {
  //     case "enquiry":
  //       route = "/view_enquiry";
  //       payload.id = taskDetails.collectionId; // ✅ 👈 store collectionId as id
  //       break;
  //     case "installation":
  //       route = "/view_installation";
  //       payload.id = taskDetails._id;
  //       break;
  //     case "recovery":
  //       route = "/viewrecovery";
  //       payload.id = taskDetails._id;
  //       break;
  //     case "compliant":
  //       route = "/compliant-view";
  //       payload.id = taskDetails._id;
  //       break;
  //     default:
  //       route = "/view_createtask";
  //       payload.id = taskDetails._id;
  //   }

  //   navigate(route, { state: payload });
  // };

  const gotoviewEnquiry = (leadId) => {
    let route = "";
    let activeTabWorkAssign = taskDetails.activeTabWorkAssign || "orderDetails";
    let taskName = taskDetails.taskName?.toLowerCase();


    let payload = {
      leadId,
      activeTabWorkAssign,
      hideButtons: true,
      taskId: taskDetails._id,
      hideAssignButton: true,
      isSubmmitedTab: true,
      reComplete:true,
    };

    console.log("taskName:", taskName);
    console.log("taskDetails.collectionId:", taskDetails.collectionId);

    switch (taskName) {
      case "enquiry":
        route = "/view_enquiry";
        payload.id = taskDetails.collectionId; // ✅ 👈 store collectionId as id
        break;
      case "installation":
        route = "/view_installation";
        payload.id = taskDetails._id;
        break;
      case "recovery":
        route = "/viewrecovery";
        payload.id = taskDetails.collectionId;
        break;
      case "complaint":
        route = "/view_complaint";
        payload.id = taskDetails.collectionId;
        break;
      case "dues":
        route = "/view_dues";
        payload.id = taskDetails.collectionId;
        break;
      default:
        route = "/view_createtask";
        payload.id = taskDetails._id;
    }

    navigate(route, { state: payload });
  };


  const gotoEnquiryApprove = (leadId) => {
    let route = "";
    let activeTabWorkAssign = taskDetails.activeTabWorkAssign || "orderDetails";
    let taskName = taskDetails.taskName?.toLowerCase();

    let payload = {
      leadId,
      taskId: taskDetails._id,
      hideButtons: true,
      hideAssignButton: true,
      isSubmmitedTab: true,
      activeTabWorkAssign,
      reComplete:true,

      // ✅ Grouped under a common key
      tabInfo: {
        activeTabWorkAssign,
        resubmittedData: true
      }
    };

    console.log("taskName:", taskName);
    console.log("taskDetails.collectionId:", taskDetails.collectionId);

    switch (taskName) {
      case "enquiry":
        route = "/view_enquiry";
        payload.id = taskDetails.collectionId;
        break;
      case "installation":
        route = "/view_installation";
        payload.id = taskDetails._id;
        break;
      case "recovery":
        route = "/viewrecovery";
        payload.id = taskDetails.collectionId;
        break;
      case "complaint":
        route = "/view_complaint";
        payload.id = taskDetails.collectionId;
        break;
      case "dues":
        route = "/view_dues";
        payload.id = taskDetails.collectionId;
        break;
      default:
        route = "/view_createtask";
        payload.id = taskDetails._id;
    }

    navigate(route, { state: payload });
  };


  // const handleAccept = () => {
  //   setShowButtons(false); // Hide Deny & Accept
  //   setShowUpdate(true); // Show Update Button
  // };

  // const handleAccept = async () => {
  //   const result = await Swal.fire({
  //     title: "Confirm Acceptance",
  //     text: "Are you sure you want to accept this task?",
  //     icon: "question",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes, Accept",
  //     cancelButtonText: "No, Cancel",
  //   });

  //   if (result.isConfirmed) {
  //     try {
  //       const now = new Date();
  //       const formattedDate = now.toLocaleDateString();
  //       const formattedTime = now.toLocaleTimeString();

  //       const payload = {
  //         _id: taskDetails._id,

  //         taskDetails: {
  //           leadId: taskDetails.leadId,
  //           taskName: taskDetails.taskName,
  //           activeTabWorkAssign: taskDetails.activeTabWorkAssign,
  //         },

  //         taskStatus: "Progress",
  //         taskAccepted: {
  //           taskAcceptedBy: staffName,
  //           id: taskDetails._id,
  //           acceptedDate: formattedDate,
  //           acceptedTime: formattedTime,
  //         },
  //       };

  //       const response = await axios.post(
  //         `${apiUrl}update-task-accept`,
  //         payload,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //           },
  //         }
  //       );

  //       if (response.data.success) {
  //         Swal.fire({
  //           title: "Task Accepted",
  //           icon: "success",
  //           confirmButtonText: "OK",
  //         });
  //         setShowButtons(false);
  //         setShowUpdate(true);
  //       }
  //     } catch (error) {
  //       console.error("Error in handleAccept:", error);
  //       Swal.fire({
  //         title: "Error",
  //         text: "Something went wrong while accepting the task.",
  //         icon: "error",
  //         confirmButtonText: "OK",
  //       });
  //     }
  //   } else {
  //     Swal.fire({
  //       title: "Cancelled",
  //       text: "Task acceptance was cancelled.",
  //       icon: "info",
  //       confirmButtonText: "OK",
  //     });
  //   }
  // };



 const handleAccept = async () => {
  const result = await Swal.fire({
    title: "Confirm Acceptance",
    text: "Are you sure you want to accept this task?",
    icon: "question",
    showCancelButton: true,
    confirmButtonText: "Yes, Accept",
    cancelButtonText: "No, Cancel",
  });

  if (!result.isConfirmed) {
    return Swal.fire({
      title: "Cancelled",
      text: "Task acceptance was cancelled.",
      icon: "info",
      confirmButtonText: "OK",
    });
  }

  try {
    const now = new Date();
    const formattedDate = now.toLocaleDateString();
    const formattedTime = now.toLocaleTimeString();

    const payload = {
      _id: taskDetails._id,
     
        leadId: taskDetails.leadId,
        taskName: taskDetails.taskName,
        activeTabWorkAssign: taskDetails.activeTabWorkAssign,
      
      taskStatus: "Progress",
     
        taskAcceptedBy: staffName,
        id: id,
        acceptedDate: formattedDate,
        acceptedTime: formattedTime,
      
    };

    // 🔹 Accept the task
    const response = await axios.post(`${apiUrl}update-task-accept`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.data.success) {
      // 🔹 Determine work type
      const name = taskDetails?.taskName?.toLowerCase() || "";
      let workType = "task";
      let pageRefId = taskDetails._id;

      if (name.includes("installation")) {
        workType = "installation";
        pageRefId = taskDetails.collectionId;
      } else if (name.includes("complaint")) {
        workType = "complaint";
        pageRefId = taskDetails.collectionId;
      } else if (name.includes("enquiry")) {
        workType = "enquiry";
        pageRefId = taskDetails.collectionId;
      } else if (name.includes("recovery")) {
        workType = "recovery";
        pageRefId = taskDetails.collectionId;
      }

      const workPayload = {
        type: workType,
        pageRefId: pageRefId,
        staffId: id,
        staffName: staffName,
        actionStatus: "accept",
      };

      await axios.post(`${apiUrl}work-detail`, workPayload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      Swal.fire({
        title: "Task Accepted",
        icon: "success",
        confirmButtonText: "OK",
      });

      setShowButtons(false);
      setShowUpdate(true);
    }
  } catch (error) {
    console.error("Error in handleAccept:", error);
    Swal.fire({
      title: "Error",
      text: "Something went wrong while accepting the task.",
      icon: "error",
      confirmButtonText: "OK",
    });
  }
};


  const handleResubmit = async () => {
    const result = await Swal.fire({
      title: "Confirm Resubmit",
      text: "Are you sure you want to resubmit this task?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Resubmit",
      cancelButtonText: "No, Cancel",
    });

    if (result.isConfirmed) {
      try {
        const now = new Date();
        const formattedDate = now.toLocaleDateString();
        const formattedTime = now.toLocaleTimeString();

        // TODO: Add your API call here if you're updating backend
        // Example:
        // await axios.post("/api/resubmit-task", {
        //   taskId: locate.state?.id,
        //   resubmittedAt: `${formattedDate} ${formattedTime}`,
        // });

        Swal.fire({
          title: "Task Resubmitted",
          icon: "success",
          confirmButtonText: "OK",
        });

        setFromApprovePerson(false);
        setShowUpdate(true);
      } catch (error) {
        console.error("Resubmission failed:", error);
        Swal.fire({
          title: "Error",
          text: "Something went wrong while resubmitting the task.",
          icon: "error",
          confirmButtonText: "OK",
        });
      }
    } else {
      Swal.fire({
        title: "Cancelled",
        text: "Task resubmission was cancelled.",
        icon: "info",
        confirmButtonText: "OK",
      });
    }
  };

  const [IsOpenTask, setIsOpenTask] = useState(false);

  // Handle file selection

  const handleSubmitUpdate = async (e) => {
    e.preventDefault();

    if (isEditMode) {
      // ✅ Check if there are any changes
      if (_.isEqual(taskDetails, originalComplaint)) {
        Swal.fire("No Changes", "No changes were made to update.", "info");
        return;
      }
    }

    const result = await Swal.fire({
      title: isEditMode ? "Update the changes?" : "Are you sure?",
      showCancelButton: true,
      confirmButtonText: isEditMode ? "Update" : "Submit",
    });

    if (result.isConfirmed) {
      try {
        if (isEditMode) {
          await axios.post(apiUrl + "update-lead-enquiry", taskDetails, {
            headers: { "Content-Type": "application/json" },
          });
          Swal.fire("Updated!", "Data updated successfully", "success");
        }

        setIsEditable(false);
        setIsEditMode(false);
      } catch (error) {
        Swal.fire(
          "Error",
          error.response?.data?.message || "Something went wrong!",
          "error"
        );
      }
    }
  };

  const listView = () => {
    axios
      .post(apiUrl + "viewlead", {})
      .then((res) => {
        setRows(res.data.message);
      })
      .catch((error) => {
        console.error("Error fetching data", error);
      });
  };

  useEffect(() => {
    listView();
  }, []);

  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const locate = useLocation();
  // const fromApprovePerson = locate.state?.fromApprovePerson;
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isEditable, setIsEditable] = useState(true);
  const [isEditMode, setIsEditMode] = useState(false);
  const id = useSelector((state) => state.id);
  const [fromApprovePerson, setFromApprovePerson] = useState(false);
  const [fromAssignPerson, setFromAssignPerson] = useState(false);

  const staffName = useSelector((state) => state.staffname);
  console.log(staffName);

  useEffect(() => {
    if (locate?.state?.fromApprovePerson !== undefined) {
      setFromApprovePerson(locate.state.fromApprovePerson);
    }
    if (locate?.state?.fromAssignPerson !== undefined) {
      setFromAssignPerson(locate.state.fromAssignPerson);
    }
  }, [locate?.state?.fromApprovePerson, locate?.state?.fromAssignPerson]);

  console.log(fromAssignPerson, "fromasignperson");

  console.log(fromApprovePerson, "approve person");

  // to track update mode
  const [originalComplaint, setOriginalComplaint] = useState(null);
  const [taskDetails, settaskDetails] = useState({});
  console.log(taskDetails);
  const [originalData, setOriginalData] = useState({});

 const handleSubmit = async () => {
  try {
    if (!reason) {
      Swal.fire("Error", "Please enter a reason for denial", "error");
      return;
    }

    // Step 1: Deny Task
    const formData = new FormData();
    formData.append("reason", reason);
    formData.append("file", file);
    formData.append("_id", taskDetails._id);
    formData.append("taskDeniedBy", staffName);
    formData.append("staffId", id);

    const response = await axios.post(apiUrl + "deny-task", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (!response.data.success) {
      Swal.fire("Error", response.data.message || "Failed to deny task", "error");
      return;
    }

    // Step 2: Handle Enquiry Save
    const savedId = response.data.data?._id;
 

    const enquiryForm = new FormData();
    enquiryForm.append("pageRefId",taskDetails._id);
    enquiryForm.append("page", "Task");
    enquiryForm.append("colorCode", "red");
    enquiryForm.append("description", reason || "");
    enquiryForm.append("staffPic", "");
    enquiryForm.append("image", selectedFile);
    enquiryForm.append("updatesHistory[staff][name]", staffName);
    enquiryForm.append("updatesHistory[staff][id]", id);
    enquiryForm.append("updatesHistory[status]", "Denied");

    await axios.post(apiUrl + "add-message", enquiryForm, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    // Step 3: Fetch messages
    // const messagesRes = await axios.get(`${apiUrl}messages/${savedId}`);
    // setMessageData(messagesRes.data.data);
    // setShowMessageBox(true);

    // Step 4: Show success and navigate
    Swal.fire("Success", "Task has been denied successfully", "success");
    setIsSubmitted(true);
    setIsEditable(false);
    setIsEditMode(false);
    handleClose();
    navigate("/task");

  } catch (error) {
    console.error("Error in handleSubmit:", error);
    Swal.fire(
      "Error",
      error.response?.data?.message || "Something went wrong",
      "error"
    );
  }
};


  useEffect(() => {
    axios
      .post(apiUrl + "getdata-task", {
        leadId: locate.state?.id,
      })
      .then((res) => {
        settaskDetails(res.data.message);
        setOriginalData(res.data.message);
        setpageRefId(res.data.message._id); // Store original data for comparison
      });
  }, [locate.state?.id, apiUrl]);

  const [showStatusPopup, setShowStatusPopup] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    settaskDetails((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Check if the leadStatus is being changed
    if (name === "leadStatus") {
      setSelectedStatus(value);
      setIsOpenConverted(true); // 👈 trigger popup
      // 👈 store selected status
    }
  };

  const handlePlanChange = (e) => {
    settaskDetails({
      ...taskDetails,
      enquiryplanDetails: {
        ...taskDetails.enquiryplanDetails,
        [e.target.name]: e.target.value,
      },
    });
  };

  const [taskData, setTaskData] = useState({
    taskName: "Enquiry",
    assignDateTime: "",
    taskType: "",
    taskPriority: "",
    deadline: "",
    time: "",
    assignedTo: [], // Array for multiple selections
    approvePerson: "",
    description: "",
    name: "",
    leadId: "",
    taskStatus: "Open",
    assignedBy: "",
  });

  useEffect(() => {
    if (staffName) {
      setTaskData((prev) => ({ ...prev, assignedBy: staffName }));
    }
  }, [staffName]);

  console.log(taskData.staffName);

  const [isOpenAssign, setIsOpenAssign] = useState(false);

  const handleInputChange = (field, value) => {
    setTaskData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const [selectedFile, setSelectedFile] = useState(null);

  const [isOpenAdvancePayment, setIsOpenAdvancePayment] = useState(false);

  // Handle file selection
  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const [isOpenplan, setIsOpenplan] = useState(false);
  const [isOpenConverted, setIsOpenConverted] = useState(false);

  function formatDate(dateString) {
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;

    return `${day}-${month}-${year} / ${hours}:${minutes} ${ampm}`;
  }

  const [selectedNames, setSelectedNames] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const names = ["Saravanan", "Ravikumar", "Sathishkumar", "Venkatesh"];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleCheckboxChange = (name) => {
    setSelectedNames((prev) =>
      prev.includes(name) ? prev.filter((n) => n !== name) : [...prev, name]
    );
  };

  const displayText =
    selectedNames.length > 0 ? selectedNames.join(", ") : "Select names";

  useEffect(() => {
    const fetchMessages = async () => {
      try {
        const response = await axios.get(`${apiUrl}messages/${pageRefId}`);

        if (response.status === 200 && Array.isArray(response.data.data)) {
          setMessageData(response.data.data); // ✅ Only the array!
        } else {
          console.error("Unexpected response structure:", response);
          setMessageData([]); // fallback to empty array
        }
      } catch (error) {
        console.error("Error fetching messages:", error);
        setMessageData([]); // fallback to empty array
      }
    };

    fetchMessages();
  }, [apiUrl, pageRefId]);

  console.log("taskData.taskName =>", taskData.taskName);

  //pending approval

  const handleApproveReject = async (taskId, status) => {
    try {
      const res = await axios.put(apiUrl + "update-approve-status", {
        id: taskId,
        approveStatus: status,
        taskDetails: {
          leadId: taskDetails.leadId,
          taskName: taskDetails.taskName,
          activeTabWorkAssign: taskDetails.activeTabWorkAssign
        }// "Approved" or "Rejected"
      });

      // if(status==="Approved"&&(taskDetails.taskName==="Installation"|| taskDetails.taskName ==="Complaint") ){
      //   if(taskDetails.activeTabWorkAssign==="fiberTeam"){

      //     const stockPayload = {

          
          
      //         }
          
            
      //           await axios.post(apiUrl + "stock/entries", stockPayload).then((res) => {
      //             navigate("/stock");
      //           });
            

      

      //   }
      //   if(taskDetails.activeTabWorkAssign==="networkTeam"){

      //   }

      // }

      Swal.fire({
        icon: "success",
        title: `Task ${status}`,
        text: res.data.message,
      }).then(() => {
        navigate("/task");
      });
    } catch (error) {
      console.error("Approve/Reject Error:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message || "Something went wrong",
      });
    }
  };


  
  return (
    <>
      <Topbar />
      <Container className="mt-1">
        <form onSubmit={handleSubmitUpdate}>
          <Row className="mb-4">
            <Col md={4}>
              <div className="ms-3">
                <h3>My Task</h3>
              </div>
            </Col>
            <Col md={8} className="text-end">
              {fromApprovePerson === true &&
                !(
                  taskDetails?.approveStatus === "Approved" ||
                  taskDetails?.approveStatus === "Resubmit"
                ) ? (
                <div>
                  <button
                    type="button"
                    onClick={() =>
                      handleApproveReject(locate.state?.id, "Resubmit")
                    }
                    className="btn btn-danger me-3"
                  >
                    Resubmit
                  </button>
                  <button
                    type="button"
                    onClick={() =>
                      handleApproveReject(locate.state?.id, "Approved")
                    }
                    className="btn btn-success"
                  >
                    Approve
                  </button>
                </div>
              ) : (
                <div>
                  <p>
                    {taskDetails.approveStatus === "Resubmit" ? (
                      <span
                        // onClick={handleResubmit}
                        // style={{ cursor: "pointer" }}
                        className="badge px-3 py-2 rounded-pill bg-danger"
                        title="Click to resubmit"
                      >
                        {taskDetails.approveStatus}
                      </span>
                    ) : (
                      <span
                        className={`badge px-3 py-2 rounded-pill ${taskDetails.approveStatus === "Approved"
                            ? "bg-success"
                            : "bg-secondary"
                          }`}
                      >
                        {taskDetails.approveStatus}
                      </span>
                    )}
                  </p>
                </div>
              )}

              {isEditMode && isEditable && (
                <>
                  <button
                    style={{ width: "100px" }}
                    className="black-btn "
                    type="button"
                    onClick={() => {
                      settaskDetails(
                        JSON.parse(JSON.stringify(originalComplaint))
                      );
                      setIsEditable(false);
                      setIsEditMode(false);
                      setShowUpdate(true);
                    }}
                  >
                    Cancel
                  </button>
                  <button className="blue-btn me-5 ms-2" type="submit">
                    Submit
                  </button>
                </>
              )}
            </Col>


            {fromAssignPerson && 
            
              taskDetails.taskStatus?.toLowerCase() === "open" &&

              showButtons && ( 
                <>
                  <Col className="mx-5 text-end">
                    <button
                      className="deny-btn me-3"
                      value="submit"
                      type="button"
                      onClick={handleShow}
                    >
                      Deny
                    </button>
                    <Modal show={show} onHide={handleClose} centered>
                      <div className="reasonfor-Deny">
                        <Modal.Header closeButton>
                          <div className="mt-3">
                            <Modal.Title className="reason-heading ms-1 ">
                              Reason
                            </Modal.Title>
                          </div>
                        </Modal.Header>
                        {/* <Modal.Body> */}
                        <div>
                          <Form>
                            <Form.Group className="mb-3">
                              <Form.Control
                                as="textarea"
                                className="reason-body"
                                rows={4}
                                placeholder="Enter Reason for Denying Task"
                                value={reason}
                                onChange={(e) => setReason(e.target.value)}
                                style={{
                                  textTransform: "capitalize",
                                  resize: "none",
                                }}
                              />
                            </Form.Group>

 <div className="upload-section">
                              <label className="upload-btn">
                                <FiUpload className="upload-icon" />
                                Upload Image
                                <input
                                  type="file"
                                  accept="image/*"
                                  onChange={handleFileChange}
                                  hidden
                                />
                              </label>
                              {selectedFile && (
                                <p className="file-name">{selectedFile.name}</p>
                              )}
                            </div>
                          </Form>
                        </div>
                        {/* </Modal.Body> */}

                        {/* <Modal.Footer> */}
                        <div className="text-end me-3 mb-4">
                          <Button
                            variant="primary"
                            className="text-center"
                            onClick={handleSubmit}
                          >
                            Submit
                          </Button>
                        </div>
                        {/* </Modal.Footer> */}
                      </div>
                    </Modal>
                    <button
                      className="blue-btn px-4 text-white"
                      value="submit"
                      type="button"
                      onClick={handleAccept}
                    >
                      Accept
                    </button>
                  </Col>
                </>
              )}

            {/*           
          <Col className="mx-5 text-end">
            <button
              className="deny-btn me-3"
              value="submit"
              type="submit"
              onClick={handleShow}
            >
              Deny
            </button>
            <Modal show={show} onHide={handleClose} centered>
              <Modal.Header closeButton>
                <Modal.Title>Reason</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form>
                  <Form.Group className="mb-3">
                    <Form.Control
                      as="textarea"
                      rows={4}
                      placeholder="Enter Reason for Denying Task"
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                    />
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <label
                      htmlFor="upload"
                      className="d-flex align-items-center gap-2"
                    >
                      <CloudUpload />
                      Upload Image
                    </label>
                    <Form.Control
                      type="file"
                      id="upload"
                      style={{ display: "none" }}
                      onChange={handleFileChange1}
                    />
                  </Form.Group>
                </Form>
              </Modal.Body>

              <Modal.Footer>
                <Button variant="primary" onClick={handleSubmit}>
                  Submit
                </Button>
              </Modal.Footer>
            </Modal>
            <button
              className="blue-btn px-4 text-white"
              value="submit"
              type="submit"
              onClick={handleAccept}
            >
              Accept
            </button>
          </Col>  */}
          </Row>

          <Row className="task-create-details">
            <div className="task-shadow">
              <form>
                <Row className="taskDetails">
                  <Col>
                    <h6 className="create-task-head">Task Details</h6>
                  </Col>
                  <Col className="text-end">
                    <div className="">
                      {/* {showUpdate && (
                      <button className="task-update" onClick={()=>gotoviewEnquiry(taskDetails?.leadId,taskDetails?._id)}>
                        Update
                      </button>
                    )} */}

                      {/* {showUpdate || taskDetails?.taskStatus === "Progress" && (
  <button 
    className="task-update" 
    onClick={() => gotoviewEnquiry(taskDetails?.leadId, taskDetails?._id)}
  >
    Update
  </button>
)} */}
                      {/* 
                      {fromAssignPerson && (showUpdate ||
                        taskDetails?.taskStatus === "Progress" ||
                        taskDetails?.taskStatus === "Hold" || (taskDetails?.taskStatus === "Completed" && taskDetails?.approveStatus == "Resubmit")) && (
                          <button
                            className="task-update"
                          onClick={() => {
  if (taskDetails?.approveStatus === "Resubmit") {
    gotoEnquiryApprove(taskDetails?.leadId, taskDetails?._id);
  } else {
    gotoviewEnquiry(taskDetails?.leadId, taskDetails?._id);
  }
}}
                          >
                            Update
                          </button>
                        )} */}

                      {(showUpdate ||
                        taskDetails?.taskStatus === "Progress" ||

                        taskDetails?.taskStatus === "Hold"|| taskDetails?.approveStatus==="Pending") && (

                          <button
                            className="task-update"
                            onClick={() => {
                              if (taskDetails?.approveStatus === "Resubmit") {
                                gotoEnquiryApprove(taskDetails?.leadId, taskDetails?._id);
                              } else {
                                gotoviewEnquiry(taskDetails?.leadId, taskDetails?._id);
                              }
                            }}
                          >
                            Update
                          </button>
                        )}
                    </div>
                  </Col>
                </Row>
                <div className="taskdetailsfirst">
                  <Row>
                    <Col sm={3}>
                      Task Created By - {taskDetails.assignedBy?.staffName}
                    </Col>
                    <Col>
                      Created Date & Time -{" "}
                      {formatDate(taskDetails.createdDate)}{" "}
                    </Col>
                  </Row>
                </div>
                <div className="create-task-head-1">
                  <Row className="g-5">
                    <Col sm={12} md={6}>
                      <Row>
                        <Col sm={12} md={6} className="text-start">
                          <lable sm={12} className="rowdown ">
                            Task Name
                          </lable>
                          <br />
                          <input
                            disabled
                            sm={12}
                            type="text"
                            required
                            value={taskDetails.taskName}
                            className="form-input-task"
                            placeholder="Enquiry"
                          />
                        </Col>

                        <Col sm={12} md={6} className="text-start">
                          <lable className="rowdown">Assign Date/Time</lable>
                          <br />
                          <input
                            // type="date"
                            className="form-input-task"
                            placeholder=""
                            value={formatDate(taskDetails.assignDateTime)}
                            disabled
                          />
                        </Col>
                      </Row>
                      {/* <Row>
                      <Col sm={12} className="text-start">
                        <lable sm={12} className="rowdown ">
                          Description
                        </lable>
                        <br />
                        <textarea
                          type="text"
                          value={taskDetails.description}
                          disabled
                          style={{
                            textTransform: "capitalize",
                            resize: "none",
                          }}
                          className="box inputfield"
                          placeholder="Enter Installation Address"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} md={6} className="text-start">
                        <lable sm={12} className="rowdown ">
                          Customer ID
                        </lable>
                        <br />
                        <input
                          sm={12}
                          type="text"
                          value={taskDetails.leadId}

                          disabled
                           required
                          className="form-input-task"
                          placeholder="A21"
                        />
                      </Col>

                      <Col sm={12} md={6} className="text-start">
                        <lable className="rowdown">Name</lable>
                        <br />
                        <input
                          type="text"
                          className="form-input-task"
                          placeholder="Manikandan"
                          value={taskDetails.name}
                          disabled
                        />
                      </Col>
                    </Row> */}

                      <Row>
                        <Col sm={12} className="text-start">
                          <label>Description</label>
                          <textarea
                            value={taskDetails.description}
                            disabled
                            className="box inputfield"
                            style={{
                              resize: "none",
                              height: "180px",
                              width: "110%",
                            }}
                          />
                        </Col>
                      </Row>
                      {[
                        "Enquiry",
                        "Installation",
                        "DueCollection",
                        "Complaint",
                        "Recovery",
                      ].includes(taskDetails.taskName) && (
                          <>
                            <Row>
                              <Col sm={12} md={6} className="text-start">
                                <label>ID</label>
                                <br/>
                                <input
                                  type="text"
                                  value={taskDetails.leadId}
                                  disabled
                                  className="form-input-task"
                                />
                              </Col>
                              <Col sm={12} md={6} className="text-start">
                                <label>Name</label>
                                <br></br>
                                <input
                                  type="text"
                                  value={taskDetails.name}
                                  disabled
                                  className="form-input-task"
                                />
                              </Col>
                            </Row>
                          </>
                        )}
                    </Col>

                    <Col sm={12} md={6}>
                      <Row>
                        {/* <Col sm={12} md={6} className="text-start">
                          <lable sm={12} className="rowdown ">
                            Task Type
                          </lable>
                          <br />
                          <select
                            value={taskDetails.taskType}
                            disabled
                            class="dropbtn form-input-select"
                          >
                            <option value="">Select</option>
                            <option className="" value="Once">
                              Once
                            </option>
                            <option className="" value="Daily">
                              Daily
                            </option>
                            <option className="" value="Weekly">
                              Weekly
                            </option>
                            <option className="" value="Monthly">
                              Monthly
                            </option>
                            <option className="" value="Custom">
                              Custom
                            </option>
                          </select>
                        </Col> */}

                        <Col sm={12} md={6} className="text-start">
                          <lable className="rowdown">Task Priority</lable>
                          <br />
                          <select
                            value={taskDetails.taskPriority}
                            disabled
                            class="dropbtn form-input-select"
                          >
                            <option value="">Select</option>
                            <option className="" value="Low">
                              Low
                            </option>
                            <option className="" value="High">
                              High
                            </option>
                            <option className="" value="Immediate">
                              Immediate
                            </option>
                          </select>
                        </Col>

                        <Col sm={12} md={6} className="text-start">
                          <lable sm={12} className="rowdown ">
                            Deadline Date/Time
                          </lable>
                          <br />
                          <input
                            disabled
                            value={formatDate(taskDetails.deadline)}
                            sm={12}
                            // type="datetime-local"
                            required
                            className="form-input-task"
                            placeholder=""
                          />
                        </Col>
                      </Row>
                      <Row className="mt-3">
                        <Col sm={12} md={6} className="text-start">
                          <lable sm={12} className="rowdown ">
                            Task Assign To
                          </lable>
                          <br />

                          <input
                            disabled
                            value={taskDetails.assignedTo
                              ?.map((person) => person.staffName)
                              .join(", ")}
                            sm={12}
                            // type="date"
                            required
                            className="form-input-task"
                            placeholder=""
                          />
                          {/* <select
                        disabled
                        value={taskDetails.assignedTo}
                          class="dropbtn form-input-select"
                        >
                          <option value="">Select</option>
                          <option className="" value="Saravanan">
                            Saravanan
                          </option>
                          <option className="" value="Ravikumar">
                            Ravikumar
                          </option>
                          <option className="" value="Sathiskumar">
                            Sathiskumar
                          </option>
                          <option className="" value="Venkatesh">
                            Venkatesh
                          </option>
                        </select> */}
                        </Col>

                        <Col sm={12} md={6} className="text-start">
                          <lable className="rowdown">Approve Person</lable>
                          <br />
                          {/* <select
                        disabled
                          class="dropbtn form-input-select"
                        >
                          <option value="">Select</option>
                          <option className="" value="Saravanan">
                            Saravanan
                          </option>
                          <option className="" value="Ravikumar">
                            Ravikumar
                          </option>
                          <option className="" value="Sathiskumar">
                            Sathiskumar
                          </option>
                          <option className="" value="Venkatesh">
                            Venkatesh
                          </option>
                        </select> */}

                          <input
                            disabled
                            value={taskDetails.approvePerson
                              ?.map((person) => person.staffName)
                              .join(", ")}
                            sm={12}
                            // type="date"
                            required
                            className="form-input-task"
                            placeholder=""
                          />
                        </Col>
                      </Row>
                      <br />

                      <Row>
                        {/* <Col sm={12} md={6} className="text-start">
                          <lable sm={12} className="rowdown ">
                            Deadline
                          </lable>
                          <br />
                          <input
                            disabled
                            value={formatDateDate(taskDetails.deadline)}
                            sm={12}
                            // type="date"
                            required
                            className="form-input-task"
                            placeholder=""
                          />
                        </Col> */}

                        <Col sm={12} md={6} className="text-start">
                          <lable className="rowdown">Task Status</lable>
                          <br />
                          {/* <input style={{ backgroundColor: "#fbdc6e", color: "rgb(94, 94, 14)",textTransform:"capitalize" }}
                      type="button"
                      onClick={() => setIsOpenConverted(true)}
                      className="form-input converted-form"
                      disabled
                    
                      value={taskDetails.taskStatus}

                    /> */}

                          <input
                            style={{
                              backgroundColor:
                                taskDetails.taskStatus?.toLowerCase() ===
                                  "completed"
                                  ? "#28a745"
                                  : taskDetails.taskStatus?.toLowerCase() ===
                                    "progress"
                                    ? "#6c757d"
                                    : "#fbdc6e",
                              color:
                                taskDetails.taskStatus?.toLowerCase() ===
                                  "completed" ||
                                  taskDetails.taskStatus?.toLowerCase() ===
                                  "progress"
                                  ? "white"
                                  : "rgb(94, 94, 14)",
                              textTransform: "capitalize",
                            }}
                            type="button"
                            onClick={() => setIsOpenConverted(true)}
                            className="form-input converted-form"
                            disabled
                            value={taskDetails.taskStatus}
                          />

                          {IsOpenTask && (
                            <div className="overlay1-open">
                              <div className="modal1-open">
                                <Container>
                                  <button
                                    className="close-btn1"
                                    onClick={() => setIsOpenTask(false)}
                                  >
                                    <span style={{ fontSize: "20px" }}>
                                      &times;
                                    </span>
                                  </button>

                                  <div className="open-button border">
                                    <h5>Open</h5>
                                  </div>

                                  <textarea
                                    style={{
                                      textTransform: "capitalize",
                                      resize: "none",
                                    }}
                                    placeholder="Enter Description"
                                    className="open-textbox"
                                  />
                                  <div className="upload-section">
                                    <label className="upload-btn">
                                      <FiUpload className="upload-icon" />
                                      Upload Image
                                      <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleFileChange}
                                        hidden
                                      />
                                    </label>
                                    {selectedFile && (
                                      <p className="file-name">
                                        {selectedFile.name}
                                      </p>
                                    )}
                                  </div>

                                  <Row>
                                    <Col className="uploadbtn-install">
                                      <button
                                        type="button"
                                        className="blue-btn"
                                        onClick={() => setIsOpenTask(false)}
                                      >
                                        Upload
                                      </button>
                                    </Col>
                                  </Row>
                                </Container>
                              </div>
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </div>
              </form>
            </div>
          </Row>

          {/* <form onSubmit={handleS
          ubmitUpdate}>  */}

          {![
            "enquiry",
            "installation",
            "complaint",
            "dues",
            "recovery",
          ].includes(taskDetails.taskName?.toLowerCase()) && (
              <Row className="container ms-3 me-5">
                {/* Message Box Column */}
                <Col md={6} sm={12}>
                  <div>
                    {Array.isArray(messageData) && messageData.length > 0 ? (
                      messageData.map((msg) => (
                        <MessageBox key={msg._id} message={msg} />
                      ))
                    ) : (
                      <div className="text-muted">No messages available.</div>
                    )}
                  </div>
                </Col>

                {/* Updates History Column */}
                <Col md={6} sm={12}>
                  <div className="compact-updates-history">
                    <div className="compact-updates-header">Updates History</div>
                    {Array.isArray(messageData) && messageData.length > 0 ? (
                      messageData.map((data, index) => (
                        <div className="compact-update text-center" key={index}>
                          <div className="compact-update-date text-center">
                            {data.updatesHistory?.date
                              ? new Date(
                                data.updatesHistory.date
                              ).toLocaleDateString("en-GB") +
                              " - " +
                              new Date(
                                data.updatesHistory.date
                              ).toLocaleTimeString("en-US", {
                                hour: "2-digit",
                                minute: "2-digit",
                                hour12: true,
                              })
                              : "No date"}
                          </div>
                          <div className="compact-update-user text-center">
                            {data.updatesHistory?.staff?.name || "Unknown"}
                          </div>
                          <div
                            className="compact-update-status text-center"
                            style={{ color: data.colorCode || "#000000" }}
                          >
                            {data.updatesHistory?.status || "No Status"}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div className="text-muted text-center">
                        No update history available.
                      </div>
                    )}
                  </div>
                </Col>
              </Row>
            )}
        </form>
      </Container>
    </>
  );
}
